import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EChartComponent } from './e-chart.component';
import { ThemeModule } from '@ex/module/shared/Theme/theme.module';



@NgModule({
  declarations: [
    EChartComponent
  ],
  imports: [
    CommonModule,
    ThemeModule
  ],
  exports: [
    EChartComponent
  ]
})
export class ZenChartModule { }
